import React from 'react';
import './Footer.scss';
import moment from 'moment';
import { TranslationUtils } from '../../utils';

export const Footer: React.FC = () => {
    const currentYear = moment().year();

    return (
        <footer className="container no-print">
            <div className="footer-content">
                <span className="copyright">© {currentYear} Vacasa LLC</span>
                <span className="service-links">
                    <a target="_blank" rel="noopener noreferrer" id="link-footer-sitemap" href="https://www.vacasa.com/sitemap">
                        {TranslationUtils.get('sitemap')}
                    </a>{' '}
                    |
                    <a target="_blank" rel="noopener noreferrer" id="link-footer-privacy" href="https://www.vacasa.com/policies">
                        {' '}
                        {TranslationUtils.get('privacy')}
                    </a>{' '}
                    |
                    <a target="_blank" rel="noopener noreferrer" id="link-footer-terms" href="https://www.vacasa.com/terms-of-service">
                        {' '}
                        {TranslationUtils.get('terms_of_service')}
                    </a>{' '}
                    |
                    <a target="_blank" rel="noopener noreferrer" id="link-footer-accessibility" href="https://www.vacasa.com/accessibility">
                        {' '}
                        {TranslationUtils.get('accessibility')}
                    </a>
                </span>
            </div>
        </footer>
    );
};
